var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrainheart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 497,
    viewBox: "0 0 425 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.235 210.867C242.907 210.867 248.55 217.326 252.592 222.195C253.01 222.699 253.79 222.67 254.191 222.152C258.428 216.677 265.658 210.867 277.245 210.867C285.461 210.867 302.715 220.726 296.142 245.374C291.043 264.496 266.988 283.103 254.548 290.705C253.865 291.123 253.003 291.081 252.362 290.603C239.678 281.139 215.168 260.072 210.695 245.374C204.944 226.477 215.624 210.867 231.235 210.867Z",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.961 309.46C118.675 317.95 117.524 335.751 139.215 339.038",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9887 305.352C74.3078 311.925 65.2701 324.084 65.2701 336.573C65.2701 352.183 83.3455 362.864 94.0264 364.508",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.069 141.852C127.712 150.068 127.877 168.472 115.388 176.359C102.9 184.247 83.3454 179.646 75.1293 176.359",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.567 75.3015C149.896 75.3015 163.041 104.058 163.041 119.668V392.442C163.041 416.269 118.675 422.02 106.35 392.442C92.3831 403.123 43.9083 394.907 47.1947 362.043C20.0817 362.864 -13.6043 311.925 15.9736 268.379C-4.56663 246.196 3.64945 205.116 36.5138 189.505C19.26 165.678 31.5841 119.668 74.3077 119.668C74.3077 88.1186 98.956 75.3015 114.567 75.3015Z",
    stroke: "black",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.343 75.3015C200.014 75.3015 186.868 104.058 186.868 119.668V392.442C186.868 416.269 231.235 422.02 243.559 392.442C257.527 403.123 306.001 394.907 302.715 362.043C329.828 362.864 363.514 311.925 333.936 268.379C354.476 246.196 346.26 205.116 313.396 189.505C330.65 165.678 318.325 119.668 275.602 119.668C275.602 88.1186 250.954 75.3015 235.343 75.3015Z",
    stroke: "black",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0264 149.246C85.5364 144.043 67.735 137.744 57.8756 147.603C46.0444 159.434 52.946 174.442 57.8756 180.467",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.848 235.515C103.338 231.955 124.919 220.069 143.323 201.008",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.318 220.726C125.247 227.847 131.492 247.346 117.031 268.379",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8706 279.06C31.0364 283.442 24.5184 296.643 29.1194 314.389C34.8706 336.573 55.4108 335.751 64.4484 332.465",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.631 35.0428L242.739 7.92969",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.857 62.1558L312.575 39.9724M319.148 92.5553L361.872 62.1558M342.975 126.241L369.266 112.274",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.229 168.965L380.769 161.57",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.553 212.51L421.028 200.186",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M373.374 263.45H403.774",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M373.374 314.389L398.844 317.676M357.764 356.291L402.952 380.94",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M333.937 389.977L361.05 412.982",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.467 422.02L324.899 447.49",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M270.673 435.166L295.322 492.678",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.631 446.668V483.641",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M264.922 45.7237L284.641 3.82166",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainheart);
export default __webpack_public_path__ + "static/media/brainheart.811215e0f328240fb11d5ff663ab53f4.svg";
export { ForwardRef as ReactComponent };